module.exports = __webpack_public_path__ + "static/img/faq.3d33300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boss-home/faq.png
// module id = xNWq
// module chunks = 1